import { Dispatch } from 'redux';
import { showFeedback } from '../../feedback/feedbackReducer';
import { screeningAlertStatusesApi } from '../../apis';
import { fetchActiveUserAlertStatusesSuccess, fetchAlertStatusesSuccess } from './alertStatusesReducer';
import {
  InternalApiAlertType,
  InternalApiBaseScreeningAlertStatus,
  InternalApiScreeningAlertStatus,
} from '../../api-internal';
import { parseErrorMessage } from '../../common/errors/helpers';

let nextFetchNotBefore = 0;

export const resetTimeouts = () => {
  nextFetchNotBefore = 0;
};

export const fetchAlertStatuses = () => async (dispatch: Dispatch) => {
  try {
    if (nextFetchNotBefore < Date.now()) {
      nextFetchNotBefore = Date.now() + 250;
      const alertStatuses = await screeningAlertStatusesApi.findAllStatuses();
      dispatch(fetchAlertStatusesSuccess(alertStatuses));
    }
  } catch (e) {
    dispatch(showFeedback({ message: await parseErrorMessage(e) }));
  }
};

export const createAlertStatus = async (newStatus: InternalApiBaseScreeningAlertStatus) => {
  await screeningAlertStatusesApi.createStatus({
    internalApiBaseScreeningAlertStatus: newStatus,
  });
};

export const updateAlertStatus = async (statusId: number, newStatus: InternalApiBaseScreeningAlertStatus) => {
  await screeningAlertStatusesApi.updateStatus({
    statusId: statusId,
    internalApiBaseScreeningAlertStatus: newStatus,
  });
};

export const deleteAlertStatus = async (statusId: number) => {
  await screeningAlertStatusesApi.deleteStatus({
    statusId: statusId,
  });
};

export const sortStatuses =
  (alertType: InternalApiAlertType, activeStatuses: InternalApiScreeningAlertStatus[]) =>
  async (dispatch: Dispatch) => {
    const sortedActiveStatuses = await screeningAlertStatusesApi.sortStatusesOrderByType({
      internalApiStatusSortOrderByType: {
        alertType,
        internalApiEntityOrder: activeStatuses.map((i, index) => ({
          id: i.code,
          order: index + 1,
        })),
      },
    });
    dispatch(fetchActiveUserAlertStatusesSuccess(sortedActiveStatuses));
    dispatch(showFeedback({ message: 'Updated statuses order', variant: 'success' }));
  };

export default {
  fetchAlertStatuses,
  createAlertStatus,
  updateAlertStatus,
  deleteAlertStatus,
  sortStatuses,
  resetTimeouts,
};
